import { useState, useEffect } from 'react';
import { getCmsContent, getCmsEntryBySlug } from '../lib/cms';

export function useCmsPage(slug) {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    async function load() {
      setLoading(true);
      const data = await getCmsEntryBySlug('pages', slug);
      if (isMounted) {
        if (data) setPage(data);
        setLoading(false);
      }
    }
    load();
    return () => { isMounted = false; };
  }, [slug]);

  return { page, loading };
}

export function useCmsGallery(gallerySlug) {
  const [gallery, setGallery] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    async function load() {
      if (!gallerySlug) {
        setLoading(false);
        return;
      }
      setLoading(true);
      const data = await getCmsEntryBySlug('galleries', gallerySlug);
      if (isMounted) {
        if (data) setGallery(data);
        setLoading(false);
      }
    }
    load();
    return () => { isMounted = false; };
  }, [gallerySlug]);

  return { gallery, loading };
}

export function useCmsProjects() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    async function load() {
      setLoading(true);
      const data = await getCmsContent('projects');
      if (isMounted) {
        if (data && data.length > 0) setProjects(data);
        setLoading(false);
      }
    }
    load();
    return () => { isMounted = false; };
  }, []);

  return { projects, loading };
}

export function useCmsMenu() {
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    async function load() {
      setLoading(true);
      const data = await getCmsContent('menu_items');
      if (isMounted) {
        if (data && data.length > 0) {
          // Sort by order
          const sorted = [...data].sort((a, b) => (Number(a.order) || 0) - (Number(b.order) || 0));
          setMenuItems(sorted);
        }
        setLoading(false);
      }
    }
    load();
    return () => { isMounted = false; };
  }, []);

  return { menuItems, loading };
}
